<div class="modal-dialog modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <div class="header">
        <img
          [src]="
            utilityService.getSanitizeUrl(profileData?.filestorage.path ?? '')
          "
          alt="project image"
          width="45rem"
          class="icon-typology" />
        <h5>{{ profileData?.first_name }} {{ profileData?.last_name }}</h5>
        <button
          type="button"
          class="btn-close align-items-start"
          data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div>
        <small class="role"
          >{{
            profileData?.assignmentrole_user[0]?.assignmentrole?.alias || ''
          }}
          {{ profileData?.assignmentrole_user[0]?.expertice || '' }}</small
        >
      </div>
    </div>
    <div class="modal-body">
      <div class="description">
        <div>
          <div>
            <p class="section-title">Hobby</p>
          </div>
          <div>
            <mat-icon class="position-absolute hobby-legend">people</mat-icon>
            <small class="legend">In comune</small>
          </div>
          <div class="row justify-content-between hobby">
            <div
              class="row col-6 align-items-center"
              *ngFor="let parent of profileData?.hobbies">
              <div class="col-auto p-1 d-flex align-items-center">
                <div class="d-flex align-items-center">
                  <button
                    class="space jus"
                    mat-fab
                    color="white"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    [matTooltip]="parent.alias">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(parent.filestorage.path)
                      "
                      class="parent-img" />
                    <mat-icon
                      *ngIf="parent.isShared == true"
                      class="position-absolute hobby-shared"
                      >people</mat-icon
                    >
                  </button>

                  <div class="pb-2" *ngIf="parent.children.length == 0">
                    {{ parent.alias }}
                  </div>
                </div>
                <div class="row img_icon" *ngFor="let child of parent.children">
                  <button
                    class="space"
                    mat-mini-fab
                    color="white"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    [matTooltip]="child.alias">
                    <img
                      [src]="
                        utilityService.getSanitizeUrl(
                          child?.filestorage.path ?? ''
                        )
                      "
                      class="child-img" />
                    <mat-icon
                      *ngIf="child?.isShared == true"
                      class="position-absolute hobbychildren-shared"
                      >people</mat-icon
                    >
                  </button>
                </div>
              </div>
            </div>
            <p class="text-menu" *ngIf="profileData?.hobbies.length == 0">
              Nessun hobby
            </p>
          </div>
        </div>

        <div *ngIf="role != 'user' && profileData?.aspirations">
          <hr />
          <div>
            <p class="section-title">Aspirazioni</p>
            <div class="justify-content-between hobby">
              <div
                class="col-6 align-items-center"
                *ngFor="let aspiration of profileData?.aspirations">
                <div class="col-auto p-1">
                  <div class="align-items-center">
                    <div class="pb-2">
                      &#x2022; {{ aspiration.description }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-menu" *ngIf="profileData?.aspirations.length == 0">
                Nessun aspirazione
              </p>
            </div>
          </div>
          <div>
            <p class="section-title">Convinzioni limitanti</p>
            <div class="justify-content-between hobby">
              <div
                class="col-6 align-items-center"
                *ngFor="let limitation of profileData?.limitations">
                <div class="col-auto p-1">
                  <div class="align-items-center">
                    <div class="pb-2">
                      &#x2022; {{ limitation.description }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-menu" *ngIf="profileData?.limitations.length == 0">
                Nessun convinzione limitante
              </p>
            </div>
          </div>
        </div>
        <hr />
        <div>
          <p class="section-title">Progetti e corsi</p>
          <div>
            <div
              class="row justify-content-between"
              *ngFor="let data of profileData?.project_user">
              <ul>
                <li class="col-6">
                  <img
                    [src]="
                      utilityService.getSanitizeUrl(
                        data.project.filestorage.path
                      )
                    "
                    data-toggle="tooltip"
                    data-placement="bottom"
                    [matTooltip]="data.project.alias"
                    width="45rem"
                    class="icon-project" />
                  →
                  {{ data.assignmentrole.alias }}
                  <small class="workdate">{{
                    data?.startwork_date | date: 'dd/MM/yyyy'
                  }}</small>
                  -
                  <small>{{
                    data?.endwork_date != null
                      ? (data?.endwork_date | date: 'dd/MM/yyyy')
                      : 'Presente'
                  }}</small>
                </li>
              </ul>
            </div>
          </div>
          <div
            *ngIf="
              !profileData?.project_user ||
              profileData?.project_user.length === 0
            ">
            <p class="p-3">Nessun progetto</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="buttons">
        <button mat-raised-button data-bs-dismiss="modal">Chiudi</button>
      </div>
    </div>
  </div>
</div>
